module.exports = __webpack_public_path__ + "img/business_creation.f330737f.svg";